export default "__VITE_ASSET__BFTKfOcf__"